module.exports = __webpack_public_path__ + "img/bg_old_town.679564d5.jpg";